<template>
  <div class="catalog-publish-modal">
    <p class="catalog-publish-modal__intro">
      Het concept wordt eerst opgeslagen en daarna als nieuwe versie vastgelegd. Bestaande versies
      veranderen niet.
    </p>

    <CatalogReleaseTiming id="catalog-publish" v-model:mode="mode" v-model:date="date" />

    <div class="modal__actions">
      <Btn text="Annuleren" variant="outlined" :disabled="loading" @click="handleCancel" />
      <Btn
        :text="mode === 'scheduled' ? 'Inplannen' : 'Publiceren'"
        variant="primary"
        :loading="loading"
        :disabled="!canSubmit"
        @click="handleSubmit"
      />
    </div>
  </div>
</template>

<script>
  import { ref, computed } from 'vue';
  import Btn from '@/components/partials/Btn.vue';
  import CatalogReleaseTiming from '@/components/products/CatalogReleaseTiming.vue';
  import { useUIStore } from '@/store/uiStore';

  export default {
    name: 'CatalogPublishModal',
    components: { Btn, CatalogReleaseTiming },
    props: {
      modalId: { type: [Number, String], required: true },
      loading: { type: Boolean, default: false },
      onSubmit: { type: Function, required: true },
    },
    setup(props) {
      const uiStore = useUIStore();
      const mode = ref('now');
      const date = ref('');

      const canSubmit = computed(() => mode.value === 'now' || Boolean(date.value));

      const handleSubmit = () => {
        if (props.loading || !canSubmit.value) return;
        props.onSubmit(mode.value === 'scheduled' ? date.value : null);
      };

      const handleCancel = () => {
        if (props.loading) return;
        uiStore.closeModal(props.modalId);
      };

      return { mode, date, canSubmit, handleSubmit, handleCancel };
    },
  };
</script>

<style scoped lang="scss">
  .catalog-publish-modal {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    &__intro {
      margin: 0;
      font-size: 0.875rem;
      color: var(--slate-600);
    }

    .modal__actions {
      display: flex;
      justify-content: flex-end;
      gap: 0.5rem;
      margin-top: 0.5rem;
    }
  }
</style>
